import script from "./segmented-survey-layout.vue?vue&type=script&setup=true&lang=js"
export * from "./segmented-survey-layout.vue?vue&type=script&setup=true&lang=js"

import "./segmented-survey-layout.vue?vue&type=style&index=0&id=2469b1e4&lang=css"

const __exports__ = script;

export default __exports__